import { baseURL } from "../../util/Constant";
import { setHtmlContent,  setError, setHtmlContentSH } from "../redux/statusFileSlice";

export const fetchOrderFile = (numOrder) => async (dispatch) => {

  // console.log(numOrder);
  try {
    const response = await fetch(`${baseURL}/email/search/${numOrder}`);
    const data = await response.json();
    // console.log('Получен файл:', data);
    dispatch(setHtmlContent(data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const fetchOrderSHFile = (tableSH) => async (dispatch) => {
  
  try {
    const response = await fetch(`${baseURL}/email/search/sh/${tableSH}`);
    const data = await response.json();
    // console.log('Получен файл:', data);
    dispatch(setHtmlContentSH(data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const fetchPutSignatureSh =(orderId, htmlContent) => async (dispatch) => {
   
    try {
      const response = await fetch(`${baseURL}/email/put/sh/signature`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderId, htmlContent }),
      });
      const data = await response.json();
      // console.log('Получен файл:', data);
      dispatch(setHtmlContent(data));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
